<template>
  <div>
    <van-popup
      v-model="localVisible"
      class="jbs-opport-pop"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <div class="obox">
        <!-- <div class="title"><span>天降幸运好职gbfgbgf</span></div>
        <div class="flag"></div> -->
        <div class="close" @click="closePop()"></div>
        <div class="jlist">
          <div
            class="job sensors_exposure"
            v-for="(item, index) in jobListData"
            sensorsname="JobShortExposure"
            :sensorsdata="
              $base.getJobShortExposureData(item, index)
            "
            :key="index"
            @click="goJobDetail(item, index)"
          >
            <div class="t">
              <div class="jname text-cut">{{ item.jobName }}</div>
              <span class="sal text-cut" v-if="item.provideSalaryString">{{ item.provideSalaryString }}</span>
            </div>
            <div class="ip">
              <span v-for="(tag, tkey) in item.jobTags"
              :key="tkey" :style="{ display: !tag ? 'none' : 'inline-block' }">{{ tag }}</span>
            </div>
            <div class="b">
              <div class="cname text-cut" v-if="item.companyName">{{ item.companyName }}</div>
              <div class="r">
                <span v-if="item.companyTypeString">{{ item.companyTypeString }}</span>
                <span v-if="item.companySizeString">{{ item.companySizeString }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tab flex flex-column align-center">
          <div class="but" :class="{disabled: delivarysJobList.length == 0}" @click="applyJob()">批量投递</div>
          <div class="leave" @click="closePop('back')">残忍离开</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions,mapState} from "vuex";
import { Popup } from "vant";
export default {
  name: 'JobRetentionPop',
  components: {
    [Popup.name]: Popup
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    showPop:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    ...mapState(["commonStore"]),
    isShow: {
      get() {
          return this.showPop && this.delivarysJobList?.length > 0;
      },
      set(value) {
          this.$emit("update:showPop", value);
      }
    }
  },
  
  watch:{
    showPop(newValue){
      if(newValue){
        console.log("触发职位挽留请求了吗");
        this.getOppoJob();
      }
    },
    //v0402： 如果页面已经存在弹窗,不再弹出引导弹窗,防止同一时间弹出多个弹窗
    isShow(newValue){
      if(newValue){
        if (this.commonStore.hasPopupVisible) {
          // 如果已经有弹窗显示，则关闭当前弹窗
          this.localVisible = false;
          return;
        }
        this.localVisible = true;
      }else{
        this.localVisible = false;
      }
    },
    //v0402： 如果页面已经存在弹窗,不再弹出引导弹窗,防止同一时间弹出多个弹窗
    localVisible(newValue){
      if(newValue){
        this.$store.commit("setPopupVisible", true);// 标记弹窗已显示
      }else{
        this.$store.commit("setPopupVisible", false);// 标记弹窗已关闭
      }
    }
  },
  data() {
    return {
      jobListData: [],//接口返回原数据
      delivarysJobList: [],//过滤完网申和已投递之后的数据
      activityZoneId: '',//同步好职专区id
      localVisible:false
    }
  },
  mounted() {
    this.activityZoneId = this.pageConfig.activityZoneId ?? ''
  },
  methods: {
    ...mapActions("applyJobStore", ["batchApplyJob"]),
    async getOppoJob() {//获取列表
      const commonStore = this.$store.state.commonStore;
      const params = {
        strategyId: this.pageConfig.popupConfigDTO?.jobRetention[0]?.id || '',//todoyyy更换为策略id测试对接接口
        cityCode: commonStore.currentAreaCode,
        funcCode: this.$route.query?.funcCode
          ? this.$route.query?.funcCode
          : commonStore.intention?.expectFunction || "",
        pageNum: 1,
        pageSize: 10,
        jobOrCompanyIdList: [],
        workFuncStr: commonStore.intention?.expectFunctionString,
        expectWorkArea: commonStore.intention?.expectArea,
        expectIndustry: commonStore.intention?.expectIndustry,
        expectIndustryNew: commonStore.intention?.expectIndustry,
        expectMinSalary: commonStore.intention?.minSalary,
        expectMaxSalary: commonStore.intention?.maxSalary,
        busBelong: this.pageConfig.busBelong || "51job",
        seekType: commonStore.intention?.seekType || "",
        userIdentity:
          commonStore.identityType == "职场人"
            ? 0
            : commonStore.identityType == "在校生"
            ? 1
            : 0,
        degree: this.$store.state.resumeStore.resume?.c.education[0]?.degree || '',
        major: this.$store.state.resumeStore.resume?.c.education[0]?.major || '',
        filterJobIds: sessionStorage.getItem("exposuredJobIds") ? JSON.parse(sessionStorage.getItem("exposuredJobIds")) : null,
        resideCity:this.$store.state.resumeStore.resume?.accountInfo?.area || '',
      };
      const property = {
        pageCode: `YC|${this.$route.params.pageId}||20|joblist||${this.activityZoneId}|${this.pageConfig.popupConfigDTO?.jobRetention[0]?.id}`,
        shortPageCode: `YC|${this.$route.params.pageId}||20|joblist||${this.activityZoneId}|${this.pageConfig.popupConfigDTO?.jobRetention[0]?.id}`,
      };
      const res = await this.$api.activity.getActivityJobList(params, {
        property,
      });
      if (res.code == '0' && res.data?.jobInfoList?.result?.length) {
        this.jobListData = res.data?.jobInfoList?.result;
        console.log("职位挽留",this.jobListData);

        this.delivarysJobList = JSON.parse(JSON.stringify(this.jobListData)).filter(//过滤掉网申和已投递的
          (item) => !item.isFromXyx && !item.isApply
        )
        if(this.delivarysJobList?.length > 0){//显示弹窗
          this.$sensors.track("PopupShow", {//埋点
            popupId: "sensor_bcop_jobretentionpopup",
            bcopExrinfo: `{"pagecode": "YC|${this.$route.params.pageId}||20|||${this.activityZoneId}|${this.pageConfig.popupConfigDTO?.jobRetention[0]?.id}"}`
          })
        }else{
          //不显示弹窗
          this.closePop("back")
        }
         this.$nextTick(() => {
          this.$exposure.sensorsExposure()
        });
      }
    },
    // 申请职位
    applyJob() {
      if (this.delivarysJobList.length > 0) {
        if (this.$base.checkLoginStatus(true)) {
          if (!this.$store.state.commonStore.accountId) {
            this.$toast.fail("投递失败，请先完善简历")
            return false
          }
          // 需过滤网申和已投递职位
          this.$toast.loading({
            message: "稍等片刻",
            forbidClick: true,
            className: "waiting-apply",
          })

          let item = this.delivarysJobList[0]
          const property = (item?.property && JSON.parse(item.property)) || {}

          this.batchApplyJob({
            jobList: this.delivarysJobList,
            property: {
              ...property,
              fromModule: "列表批投",
            },
            onResult: ({ allSuccess, arrSuccess, arrFail, resultArr }) => {
              console.log(
                "onResult",
                allSuccess,
                arrSuccess,
                arrFail,
                resultArr
              )

              if (allSuccess) {
                this.$toast.clear()
                this.$toast("投递成功")
                this.closePop()
              } else {
                this.$toast.clear()
                this.$toast.fail("部分职位需要进入详情页单独投递~")
              }
              this.$store.commit("setValueLocalStorage", {
                applyJobRefreshTasks:
                  this.$store.state.commonStore.applyJobRefreshTasks + 1,
              })
            }
          })
          return
        }
      }
    },
    //跳转职位详情
    goJobDetail(item, index) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist",
        moduleName: "|",
        contentName: "职位挽留弹窗",
        contentType: "职位",
        contentId: item.jobId,
        contentRank: `${index}`,
        requestId: this.$route.query.requestId,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}||20|joblist||${this.activityZoneId}|${this.pageConfig.popupConfigDTO?.jobRetention[0]?.id}`,
        },
      })

      if (!this.$base.checkLoginStatus(true)) return
      this.$base.toJobDetail(item, index)
    },
    closePop(type) {//type-back:继续走返回逻辑
      this.isShow = false;
      if(type == 'back'){
        console.log("走公用返回方法",this.pageConfig?.prevLink);
        this.$base.goBack(this.pageConfig?.prevLink);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pc .jbs-opport-pop {
  top: 30% !important;
}
.jbs-opport-pop {
  width: 96%;
  // background: linear-gradient(to bottom, #FFEAA7, #FFFFFF);
  background: transparent;
  border-radius: 15px;
  overflow: visible;
  .obox {
    background: url("./img/jobRetentionBg.png") left top no-repeat;
    background-size: 100% auto;
    padding-top: 20px;
    margin-top: -20px;
    .title {
      height: 50px;
      line-height: 50px;
      text-align: center;

      span {
        position: relative;
        font-size: 20px;
        font-weight: 600;
        background: linear-gradient(180deg, #FF5500 0%, #FF9513 100%);
        background-clip: text;
        color: transparent;
      }

      span::after, span::before {
        position: absolute;
        width: 20px;
        height: 11px;
        content: '';
        top: 50%;
        left: -26px;
        margin-top: -5px;
        background: url(~@/assets/img/activity/pop/pop_title_left@2x.png) no-repeat;
        background-size: 100% auto;
      }

      span::after {
        left: auto;
        right: -26px;
        background-image: url(~@/assets/img/activity/pop/pop_title_right@2x.png);
      }
    }

    .flag {
      position: absolute;
      width: 198px;
      height: 93px;
      left: 0;
      top: -60px;
      background: url(~@/assets/img/activity/pop/pop_flag@2x.png) no-repeat;
      background-size: 100% auto;
    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      right: 0;
      top: -36px;
      background: url(~@/assets/img/activity/pop/pop_close@2x.png) no-repeat;
      background-size: 100% auto;
    }

    .jlist {
      min-height: 106px;
      max-height: 342px;
      padding: 0px 8px 8px;
      margin-top: 70px;
      overflow: auto;
      background: #FFFCE1;
      .job {
        position: relative;
        padding: 10px 12px 12px;
        margin-bottom: 6px;
        border-radius: 12px;
        background: #fff;

        .t {
          display: flex;
        }

        .sal {
          max-width: 150px;
          font-size: 15px;
          font-weight: 500;
          line-height: 20px;
          text-align: right;
          color: #FF5500;
        }

        .jname {
          flex: 1;
          font-size: 17px;
          font-weight: 600;
          line-height: 21px;
          color: #222;
        }

        .ip {
          height: 20px;
          margin: 8px auto 10px;
          overflow: hidden;

          span {
            white-space: nowrap;
            padding: 2px 6px;
            border-radius: 4px;
            background: #F4F8FB;
            font-size: 12px;
            font-weight: normal;
            line-height: 16px;
            margin-right: 4px;

            &:last-child {
              margin-right: 0;
            }
          }
        }

        .b {
          display: flex;
        }

        .cname {
          font-size: 14px;
          font-weight: normal;
          line-height: 17px;
          color: #4C4F54;
        }

        .r {
          max-width: 250px;
          font-size: 14px;
          font-weight: normal;
          line-height: 17px;
          color: #4C4F54;
          flex: 0 0 auto;
          span {
            margin-right: 8px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }

    .tab {
      padding: 16px 16px 12px;
      border-radius: 0 0 12px 12px;
      background: linear-gradient(181deg, #FFEAA7 3%, #FFFFFF 99%), linear-gradient(181deg, #E5F6F2 20%, #D3F3FE 99%);

      .but {
        width: 200px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #FFF;
        margin: 0 auto;
        border-radius: 22px;
        background: linear-gradient(180deg, #FFB240 2%, #FF6300 100%);
        box-shadow: inset 0px 3px 9px 0px #FF6906;
        &.disabled {
          opacity: .6;
        }
      }
      .leave{
        text-align: center;
        font-size: 14px;
        color: #8C8F8D;
        margin-top: 8px;
      }
    }
  }
}
</style>